/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createScheduledTransactionGetResponseFromDiscriminatorValue, type ProblemDetails, type ScheduledTransactionGetResponse } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /scheduledtransactions/account/{accountId}
 */
export interface WithAccountItemRequestBuilder extends BaseRequestBuilder<WithAccountItemRequestBuilder> {
    /**
     * Retrieves a list of scheduled transactions for the specified account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ScheduledTransactionGetResponse[]>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ScheduledTransactionGetResponse[] | undefined>;
    /**
     * Retrieves a list of scheduled transactions for the specified account
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithAccountItemRequestBuilderUriTemplate = "{+baseurl}/scheduledtransactions/account/{accountId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithAccountItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithAccountItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createScheduledTransactionGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
